import classNames from 'classnames';
import values from 'lodash/values';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import StationShuffleIcon from '../../../static/icons/station-shuffle.svg';
import * as Actions from '../../actions';
import Icon from '../../components/Icon/Icon';
import Eq from '../../components/lib/Eq/Eq';
import SingleToggleButton from '../../components/ToggleButtons/SingleToggleButton';
import * as Constants from '../../constants';
import { EqColors, EqSizes } from '../../constants/Eq';
import { getInDomain } from '../../domains/externalUtils';

import ShuffleDropdownCaret from './ShuffleDropdownCaret';

import './ShuffleButton.scss';

const STYLES = Constants.Shuffle.buttonStyles;

export class ShuffleButton extends React.Component {
  static propTypes = {
    playResumeSource: PropTypes.func.isRequired,
    startNextNonShuffleStation: PropTypes.func.isRequired,
    isShuffleActive: PropTypes.bool.isRequired,
    isPlaying: PropTypes.bool.isRequired,
    style: PropTypes.oneOf(values(STYLES)),
    isContainerActive: PropTypes.bool,
    onChildFocused: PropTypes.func,
    onChildBlurred: PropTypes.func,
  };

  static defaultProps = {
    style: STYLES.DEFAULT,
  };

  isListItem = () => {
    return this.props.style === STYLES.COMPACT;
  };

  isCompact = () => {
    return this.props.style === STYLES.COMPACT || this.props.style === STYLES.COMPACT_MIN;
  };

  toggleShuffle = () => {
    if (!this.props.isShuffleActive) {
      this.props.playResumeSource({
        pandoraType: Constants.SourceTypes.PandoraTypes.USER_STATION,
        shouldShuffle: true,
      });
    } else {
      this.props.startNextNonShuffleStation();
    }
  };

  getSingleButtonContent = () => {
    const { shuffleStations, shuffleOn } = Constants.MyStations.messages;
    const shuffleMessage = this.props.isShuffleActive ? shuffleOn : shuffleStations;
    const equalizerClass = classNames('ShuffleButton__button__shuffleEqualizer', {
      'ShuffleButton__button__shuffleEqualizer--playing': this.props.isPlaying,
    });

    const shuffleSpan = (
      <span key='shuffleString' className='ShuffleButton__button__shuffleString'>
        <FormattedMessage {...shuffleMessage} />
      </span>
    );

    const eqColor = this.props.style === STYLES.WHITE ? EqColors.BLACK : EqColors.WHITE;

    const shuffleEq = (
      <div className={equalizerClass} key='shuffle__equalizer'>
        <Eq isPlaying={this.props.isPlaying} size={EqSizes.XSMALL} color={eqColor} />
      </div>
    );

    if (!this.props.isShuffleActive) {
      return [
        <Icon className='icon-shuffle' key='icon-shuffle' glyph={StationShuffleIcon} />,
        shuffleSpan,
      ];
    }

    return [shuffleEq, shuffleSpan];
  };

  renderShuffleDropdownCaret = () => {
    if (this.isCompact() || !this.props.isShuffleActive) {
      return;
    }

    const caretProps = {
      extraClass: 'ShuffleButton__button__caret',
      key: 'drop-caret',
      style: this.props.style,
    };
    return <ShuffleDropdownCaret {...caretProps} />;
  };

  render() {
    // This class will get selected and hover attributes from the single toggle button class
    const buttonClass = classNames(`ShuffleButton__button--${this.props.style}`);

    const singleButtonToggle = {
      button: {
        title: this.getSingleButtonContent(),
        action: () => this.toggleShuffle(),
        isSelected: this.props.isShuffleActive,
        isActive: this.props.isContainerActive,
        className: buttonClass,
        onChildFocused: this.props.onChildFocused,
        onChildBlurred: this.props.onChildBlurred,
      },
    };

    return (
      <div className='ShuffleButton'>
        <SingleToggleButton {...singleButtonToggle} />
        {this.renderShuffleDropdownCaret()}
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    isShuffleActive: getInDomain('playback.utils.isInShuffleMode', false)(state),
    isPlaying: getInDomain('playback.utils.isAudioPlaying', false)(state) || false,
  };
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      playResumeSource: Actions.UseCases.playResumeSource,
      startNextNonShuffleStation: getInDomain('playback.actions.startNextNonShuffleStation'),
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ShuffleButton);
